/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/TryParseVersionFromMultiLineContent.ts
 * @create:      2025-07-01 18:02:03.697
 * @modify:      2025-07-11 21:19:12.960
 * @version:     6.0.0
 * @times:       4
 * @lines:       65
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { IParsedVersion } from "../interface/IParsedVersion";
import { ParseLines } from "./ParseLines";
import { TryParseVersion } from "./TryParseVersion";

/**
 * Attempts to parse a version string from a multi - line content.
 * Iterates through each line of the content and uses the TryParseVersion function to find a valid version.
 * 
 * @param content - The multi - line string content from which to parse the version.
 * @returns An object containing the end - of - line sequence, all lines, the line containing the version,
 * and the parsed version if found; otherwise, undefined.
 * 
 * @since 5.0.0
 * @version 2025-06-18
 */
export function TryParseVersionFromMultiLineContent(content: string): IParsedVersion | undefined {
    const { endOfLineSequence, lines } = ParseLines(content);

    for (const line of lines) {
        const version = TryParseVersion(line);
        if (version !== undefined) {
            return {
                endOfLineSequence,
                lines,
                versionLine: line,
                version,
            };
        }
    }

    return undefined;
}
